import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Alert } from "@mui/material";

import { string } from "yup";

import { login, resetPassword } from "../../services/login";

function FormLogin() {
	const [email, setEmail] = useState("");
	const [senha, setSenha] = useState("");

	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingPasswordResponse, setLoadingPasswordResponse] =
		useState(false);

	const [serverResponse, setServerResponse] = useState("");
	const [resetPasswordResponse, setResetPasswordResponse] = useState("");

	const [error, setError] = useState({
		email: false,
		senha: false,
	});

	const [helperText, setHelperText] = useState({
		email: "",
		senha: "",
	});

	const validateEmail = () => {
		if (email !== "" && string().email().isValidSync(email)) {
			setError({
				...error,
				email: false,
			});
			setHelperText({
				...helperText,
				email: "",
			});
		} else if (email === "" || email === null) {
			setError({
				...error,
				email: true,
			});
			setHelperText({
				...helperText,
				email: "Obrigatório",
			});
		} else {
			setError({
				...error,
				email: true,
			});
			setHelperText({
				...helperText,
				email: "E-mail Inválido",
			});
		}
	};

	const validateSenha = () => {
		if (senha === "") {
			setError({
				...error,
				senha: true,
			});
			setHelperText({
				...helperText,
				senha: "Obrigatório",
			});
		} else if (senha.length < 7) {
			setError({
				...error,
				senha: true,
			});
			setHelperText({
				...helperText,
				senha: "A senha deve conter pelo menos 8 caracteres",
			});
		} else {
			setError({
				...error,
				senha: false,
			});
			setHelperText({
				...helperText,
				senha: "",
			});
		}
	};

	const salvarLocalStorage = (response) => {
		localStorage.setItem("token", response.data.token);
		localStorage.setItem("refresh_token", response.data.refresh_token);
		// localStorage.setItem("permissao_cadastrar", response.data.permissao_cadastrar);
		localStorage.setItem("usuario_admin", response.data.usuario_admin);
		// localStorage.setItem("usuario_gestor", response.data.usuario_gestor);
		localStorage.setItem("org", response.data.org);
		localStorage.setItem("isAuthenticated", true);
	};

	const definirTempoDeLogout = () => {
		let now = new Date().getTime();
		localStorage.setItem("setupTime", now);
	};

	const validadeLoginPasswordOrEmailInvalid = (errors) => {
		if (errors.response.data.response) {
			setServerResponse(errors.response.data.response);
			setError({
				email: true,
				senha: true,
			});
		}
	};

	const validadeLoginEmptyForm = (errors) => {
		setHelperText({
			email: errors.response.data.email,
			senha: errors.response.data.password,
		});
		setError({
			email: errors.response.data.email ? true : false,
			senha: errors.response.data.password ? true : false,
		});
	};

	const postLogin = (data) => {
		login(data)
			.then(function (response) {
				salvarLocalStorage(response);
				definirTempoDeLogout();

				setIsLoading(false);
				window.location = "/";
			})
			.catch(function (errors) {
				console.log(errors);

				validadeLoginEmptyForm(errors);
				validadeLoginPasswordOrEmailInvalid(errors);

				setIsLoading(false);
			});
	};

	const handleLogin = (e) => {
		e.preventDefault();
		setIsLoading(true);

		const loginData = {
			email: email,
			password: senha,
		};

		postLogin(loginData);
	};

	const handleResetPassword = (e) => {
		e.preventDefault();

		setLoadingPasswordResponse(true);

		resetPassword(email)
			.then(function (response) {
				setResetPasswordResponse(
					"Verifique seu e-mail para redefinir sua senha."
				);
				setLoadingPasswordResponse(false);
			})
			.catch(function (errors) {
				console.log(errors);

				setHelperText({
					email: errors.response.data.email,
				});
				setError({
					email: true,
				});
				setLoadingPasswordResponse(false);
			});
	};

	return (
		<Form noValidate onSubmit={handleLogin}>
			<div className="p-4 row d-flex justify-content-center">
				<div style={{ maxWidth: 500 }}>
					<div className="my-3 col-sm-12 col-md-12 col-lg-12">
						<TextField
							fullWidth
							label="Email"
							error={error.email}
							helperText={helperText.email}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							onBlur={() => validateEmail()}
						/>
					</div>

					<div className="my-3 col-sm-12 col-md-12 col-lg-12">
						<TextField
							fullWidth
							label="Senha"
							type="password"
							helperText={helperText.senha}
							error={error.senha}
							value={senha}
							onChange={(e) => setSenha(e.target.value)}
							onBlur={() => validateSenha()}
						/>
					</div>

					{serverResponse !== "" && (
						<Alert
							className="mt-3"
							severity="error"
							onClose={() => {
								setServerResponse("");
							}}
						>
							{serverResponse}
						</Alert>
					)}

					{resetPasswordResponse !== "" && (
						<Alert
							className="mt-3"
							severity="success"
							onClose={() => {
								setResetPasswordResponse("");
							}}
						>
							{resetPasswordResponse}
						</Alert>
					)}

					{isLoadingPasswordResponse ? (
						<CircularProgress size={25} />
					) : (
						<Button
							size="small"
							onClick={handleResetPassword}
							disabled={isLoadingPasswordResponse}
						>
							Esqueci minha senha
						</Button>
					)}
				</div>
			</div>

			<div className="d-flex justify-content-center mt-4">
				{isLoading ? (
					<CircularProgress size={30} />
				) : (
					<Button
						variant="outlined"
						type="submit"
						disabled={isLoading}
					>
						Enviar
					</Button>
				)}
			</div>
		</Form>
	);
}

export default FormLogin;
